import React, { memo } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { RiFilterFill, RiFilterOffFill } from 'react-icons/ri';
import { FaFilter } from "react-icons/fa";

interface Props {
  Component1?: React.ElementType;
  Component2?: React.ElementType;
  Component3?: React.ElementType;
  Component4?: React.ElementType;
  Component5?: React.ElementType;
  Component6?: React.ElementType;
  Component7?: React.ElementType;
  Component8?: React.ElementType;
  Component9?: React.ElementType;
  Component10?: React.ElementType;
  Component11?: React.ElementType;
  Component12?: React.ElementType;
  Component13?: React.ElementType;
  Component14?: React.ElementType;
  Component15?: React.ElementType;
  Component16?: React.ElementType;
  Component17?: React.ElementType;
  Component18?: React.ElementType;
  Component19?: React.ElementType;
  Component20?: React.ElementType;
  Component21?: React.ElementType;
  applyFilter: () => void;
  clearFilter: () => void;
  height?: any;
  id: string;
  isFilterActive?: boolean;
}
function GlobalSearch({
  applyFilter,
  clearFilter,
  isFilterActive,
  Component1,
  Component2,
  Component3,
  Component4,
  Component5,
  Component6,
  Component7,
  Component8,
  Component9,
  Component10,
  Component11,
  Component12,
  Component13,
  Component14,
  Component15,
  Component16,
  Component17,
  Component18,
  Component19,
  Component20,
  Component21,
  height,
  id,
}: Props) {
  const filterHightUp = () => {
    if (height) {
      //const scrollHeight = $('.filter-page')[0].scrollHeight; - auto
      $('.filter-page').css({
        height: height,
      });
      $('.hideUp').hide();
      $('.hideDown').show();
    } else {
      $('.filter-page').css({
        height: '260px',
      });
      $('.hideUp').hide();
      $('.hideDown').show();
    }
  };
  const filterHightDown = () => {
    $('.hideUp').show();
    $('.hideDown').hide();
    $('.filter-page').css({
      height: '100px',
    });
  };
  const handleToggle = () => {
    if ($('.hideUp').is(':visible')) {
      filterHightUp();
    } else {
      filterHightDown();
    }
  };
  return (
    <div className={id}>
      <div className='filter-page'>
        <div className='filter-child'>
          <div className='filter-icon' onClick={handleToggle} 
            style={{ cursor: 'pointer', userSelect: 'none' }}>
            <div style={{marginLeft: 4, marginTop: 1}} className='first-icon'>
              <FaFilter
                size={16}
                color={isFilterActive ? '#23d2ee' : '#FFA500'}
                style={{ marginRight: 8 }} />
              Filter
            </div>
            <div className='second-icon' style={{marginTop: 1, marginRight: 2}}>
              <div className='hideUp'>
                <IoIosArrowUp size={20} />
              </div>
              <div className='hideDown'>
                <IoIosArrowDown size={20} />
              </div>
            </div>
          </div>
          <div className='filter-content'>
            <div className='filter-body'>
              <div className='row mb-3'>
                <div className='col-md-12'>
                  <div className='roster-grafik'>
                    {Component1 && <Component1 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component2 && <Component2 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component8 && <Component8 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component21 && <Component21 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component3 && <Component3 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component16 != undefined &&
                      process.env.REACT_APP_ERP_TYPE != 'MEX' ? (
                      <Component16 />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component13 && <Component13 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component17 && <Component17 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component18 && <Component18 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component19 && <Component19 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component4 && <Component4 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component5 && <Component5 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component7 && <Component7 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component9 && <Component9 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component11 && <Component11 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component10 && <Component10 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component12 && <Component12 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component6 && <Component6 />}
                  </div>
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component20 && <Component20 />}
                  </div>
                  {/* <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component14 && <Component14 />}
                  </div> */}
                  <div className='roster-grafik' style={{ marginTop: 10 }}>
                    {Component15 != undefined &&
                      process.env.REACT_APP_ERP_TYPE == 'PRONTO' ? (
                      <Component15 />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='filter-footer'>
              <div className='btn-filter w-100' onClick={applyFilter}>
                <span>
                  <RiFilterFill size={15} color='#f7b731' />
                </span>
                <span>Apply filter</span>
              </div>
              <div className='btn-clear-filter  w-100' onClick={clearFilter}>
                <span>
                  <RiFilterOffFill size={15} color='red' />
                </span>
                <span>Clear filter</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(GlobalSearch);
